"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var api_1 = require("../../utils/api");
var graphql_1 = require("graphql");
var constants_1 = require("./constants");
var config_1 = __importStar(require("../../config"));
var getQueuedRecordings_1 = __importDefault(require("./queries/getQueuedRecordings"));
var recordProgram_1 = __importDefault(require("./queries/recordProgram"));
var selectors_1 = require("../devices/selectors");
var selectors_2 = require("../customer/selectors");
var cancelRecordProgram_1 = __importDefault(require("./queries/cancelRecordProgram"));
var recordSeriesLink_1 = __importDefault(require("./queries/recordSeriesLink"));
var cancelRecordSeriesLink_1 = __importDefault(require("./queries/cancelRecordSeriesLink"));
var recordMultiple_1 = __importDefault(require("./queries/recordMultiple"));
exports.setAllRecordings = function (recordingsData) {
    return toolkit_1.createAction(constants_1.SET_ALL_RECORDINGS)(recordingsData);
};
exports.removeRecordings = function (ids) { return toolkit_1.createAction(constants_1.REMOVE_RECORDING)(ids); };
exports.setRecordingSettings = function (recordingSettings) {
    return toolkit_1.createAction(constants_1.SET_RECORDING_SETTINGS)(recordingSettings);
};
exports.setPlannerSorting = function (sort) {
    return toolkit_1.createAction(constants_1.SET_PLANNER_SORTING)(sort);
};
exports.setScheduledRecordingSet = function (recordingSet) {
    return toolkit_1.createAction(constants_1.SET_SCHEDULED_RECORDING_SET)(recordingSet);
};
exports.fetchScheduledRecordings = function () { return function (dispatch, getState) {
    var deviceId = selectors_1.getSerialNumber(getState());
    return dispatch(api_1.createApiAction(constants_1.FETCH_SCHEDULED_RECORDINGS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getQueuedRecordings_1.default,
            variables: { deviceId: deviceId },
        },
        authenticated: true,
        graphQL: true,
    }));
}; };
exports.recordSlot = function (slotId) { return function (dispatch, getState) {
    var deviceId = selectors_1.getSerialNumber(getState());
    var profileId = selectors_2.selectedProfileId(getState());
    return dispatch(api_1.createApiAction(constants_1.RECORD_PROGRAMME, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: graphql_1.print(recordProgram_1.default),
            variables: { slotId: slotId, deviceId: deviceId, profileId: profileId },
        },
        authenticated: true,
        graphQL: true,
        onSuccess: function (_, _a) {
            var payload = _a.payload;
            var _b;
            if (((_b = payload.recordProgram) === null || _b === void 0 ? void 0 : _b.__typename) === 'QueuedRecordingSet') {
                dispatch(exports.setScheduledRecordingSet(payload.recordProgram));
            }
        },
    }));
}; };
exports.cancelRecordSlot = function (slotId) { return function (dispatch, getState) {
    var deviceId = selectors_1.getSerialNumber(getState());
    return dispatch(api_1.createApiAction(constants_1.CANCEL_RECORD_PROGRAMME, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: graphql_1.print(cancelRecordProgram_1.default),
            variables: { slotId: slotId, deviceId: deviceId },
        },
        authenticated: true,
        graphQL: true,
        onSuccess: function (_, _a) {
            var payload = _a.payload;
            dispatch(exports.setScheduledRecordingSet(payload.cancelRecordProgram));
        },
    }));
}; };
exports.recordSeriesLink = function (seriesLinkId) { return function (dispatch, getState) {
    var deviceId = selectors_1.getSerialNumber(getState());
    var profileId = selectors_2.selectedProfileId(getState());
    return dispatch(api_1.createApiAction(constants_1.RECORD_SERIES_LINK, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: graphql_1.print(recordSeriesLink_1.default),
            variables: { seriesLinkId: seriesLinkId, deviceId: deviceId, profileId: profileId },
        },
        authenticated: true,
        graphQL: true,
        onSuccess: function (_, _a) {
            var payload = _a.payload;
            var _b;
            if (((_b = payload.recordSeriesLink) === null || _b === void 0 ? void 0 : _b.__typename) === 'QueuedRecordingSet') {
                dispatch(exports.setScheduledRecordingSet(payload.recordSeriesLink));
            }
        },
    }));
}; };
exports.cancelRecordSeriesLink = function (seriesLinkId) { return function (dispatch, getState) {
    var deviceId = selectors_1.getSerialNumber(getState());
    return dispatch(api_1.createApiAction(constants_1.CANCEL_RECORD_SERIES_LINK, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: graphql_1.print(cancelRecordSeriesLink_1.default),
            variables: { seriesLinkId: seriesLinkId, deviceId: deviceId },
        },
        authenticated: true,
        graphQL: true,
        onSuccess: function (_, _a) {
            var payload = _a.payload;
            dispatch(exports.setScheduledRecordingSet(payload.cancelRecordSeriesLink));
        },
    }));
}; };
exports.resetRecordProgramme = function () { return toolkit_1.createAction(constants_1.RESET_RECORD_PROGRAMME)(); };
exports.resetRecordSeriesLink = function () { return toolkit_1.createAction(constants_1.RESET_RECORD_SERIES_LINK)(); };
exports.migrateRecordings = function (slots, migrateShowIds) { return function (dispatch, getState) {
    var _a;
    var deviceId = selectors_1.getSerialNumber(getState());
    var customerProfiles = selectors_2.getCustomerProfiles(getState());
    var activeProfileId = selectors_2.selectedProfileId(getState());
    var defaultProfileId = (_a = customerProfiles === null || customerProfiles === void 0 ? void 0 : customerProfiles.find(function (profile) { return profile.isDefault === true; })) === null || _a === void 0 ? void 0 : _a.id;
    var programs = slots === null || slots === void 0 ? void 0 : slots.map(function (_a) {
        var slotId = _a.slotId, profileId = _a.profileId;
        var targetProfile = customerProfiles === null || customerProfiles === void 0 ? void 0 : customerProfiles.find(function (profile) { return profile.id === profileId; });
        return {
            slotId: slotId,
            // fall back to the default profile id if the profile is deleted
            profileId: (targetProfile === null || targetProfile === void 0 ? void 0 : targetProfile.id) || defaultProfileId,
        };
    });
    var migrateShows = migrateShowIds === null || migrateShowIds === void 0 ? void 0 : migrateShowIds.map(function (showId) { return ({
        showId: showId,
        // we haven't saved profile id for series link before, set the active profile id as default
        profileId: activeProfileId,
    }); });
    return dispatch(api_1.createApiAction(constants_1.MIGRATE_RECORDINGS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: graphql_1.print(recordMultiple_1.default),
            variables: { deviceId: deviceId, programs: programs, migrateShows: migrateShows },
        },
        authenticated: true,
        graphQL: true,
        onSuccess: function (_, _a) {
            var payload = _a.payload;
            var _b;
            dispatch(exports.setScheduledRecordingSet((_b = payload.recordMultiple) === null || _b === void 0 ? void 0 : _b.queuedRecordingSet));
        },
    }));
}; };
exports.setMigrationCompleted = function () { return toolkit_1.createAction(constants_1.SET_MIGRATION_COMPLETED)(); };
//# sourceMappingURL=actions.js.map